import { type DashboardFlags } from 'localFlagValues';

import { useFlagsWithOverrides } from './useFlagsWithOverrides';

export const useFlagEnabledWithOverrides = (
  flagName: DashboardFlags
): boolean => {
  const flags = useFlagsWithOverrides([flagName]);
  return flags[flagName].enabled;
};
